export default "__VITE_ASSET__BJR0VBOr__"